import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { baseGrid, siteWide } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { h4, paragraph, paragraphLarge } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.div `
  ${siteWide};
`;
const Intro = styled.div `
  padding-top: ${fluid(60, 100)};

  @media ${from(Device.Tablet)} {
    ${baseGrid};
  }
`;
const IntroTitleArea = styled.h2 `
  ${h4};
  grid-column: span 6;
`;
const IntroContentArea = styled.p `
  grid-column: 8 / span 5;
  ${paragraph};
  margin-bottom: 0;
`;
const SeminarsList = styled.div `
  ${baseGrid};
  padding-top: ${fluid(35, 70)};
  grid-template-columns: 1fr;
  gap: ${fluid(20, 40)};

  @media ${from(Device.TabletSmall)} {
    grid-template-columns: repeat(2, 1fr);
  }
`;
const ListingTotals = styled.div `
  padding-top: ${fluid(30, 60)};
  padding-bottom: 0;
`;
const ListingTotalsText = styled.p `
  ${paragraphLarge};
  ${fonts.montserrat.medium};
  margin-bottom: 0;
`;
const PaginationContainer = styled.div `
  padding-top: ${fluid(0, 20)};
  padding-bottom: ${fluid(30, 60)};
`;
export const SeminarsListStyles = {
    Container,
    Intro,
    IntroContentArea,
    IntroTitleArea,
    ListingTotals,
    ListingTotalsText,
    PaginationContainer,
    SeminarsList,
};
